import React, { useCallback } from 'react'
import { getIn } from 'formik'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import InstagramStoryThumbnail from './InstagramStoryThumbnail'
import StoryButton from './StoryButton'

import {
  CALL_TO_ACTION,
  STORIES_ITEM_SELECTED_INDEX,
  STORIES_ITEMS
} from '../../../../../forms/Facebook/AdForms/fields'
import {
  FILE_ID,
  FILE_NAME,
  FILE_URL,
  IMAGE_HASH,
  MEDIA_TYPE,
  VIDEO_PICTURE
} from '../../../../../forms/ReusableFormFields/AdFileUpload/fields'

import useStyles from './styles'

const InstagramStoriesItem = ({
  viewAdOnFacebook,
  formikValues,
  elementInProgress,
  index,
  fileUrl,
  handleLeftSideClick,
  handleRightSideClick,
  isSoundMuted,
  mediaThumbnailImageRatio
}) => {
  const storiesItems = formikValues[STORIES_ITEMS]
  const selectedStoriesItemIndex = formikValues[STORIES_ITEM_SELECTED_INDEX]
  const isActive = selectedStoriesItemIndex === index && elementInProgress === STORIES_ITEMS

  const classes = useStyles({ selectedStoriesItemIndex, fileUrl })

  // ACTION BUTTON
  const actionValue = getIn(formikValues, `${STORIES_ITEMS}[${index}].${CALL_TO_ACTION}`)

  const storiesItem = getIn(formikValues, `${STORIES_ITEMS}[${index}]`)

  const mediaFile = {
    [MEDIA_TYPE]: getIn(storiesItem, MEDIA_TYPE),
    [FILE_NAME]: getIn(storiesItem, FILE_NAME),
    [FILE_URL]: getIn(storiesItem, FILE_URL),
    [IMAGE_HASH]: getIn(storiesItem, IMAGE_HASH),
    [VIDEO_PICTURE]: getIn(storiesItem, VIDEO_PICTURE),
    [FILE_ID]: getIn(storiesItem, FILE_ID)
  }

  const leftSideClick = useCallback(() => {
    if (handleLeftSideClick && selectedStoriesItemIndex !== 0) {
      handleLeftSideClick()
    }
  }, [handleLeftSideClick, selectedStoriesItemIndex])

  const rightSideClick = useCallback(() => {
    if (handleRightSideClick && selectedStoriesItemIndex !== storiesItems.length - 1) {
      handleRightSideClick()
    }
  }, [handleRightSideClick, selectedStoriesItemIndex, storiesItems])

  return (
    <div className={classes.AdStoriesItem}>
      <InstagramStoryThumbnail
        viewAdOnFacebook={viewAdOnFacebook}
        mediaFile={mediaFile}
        isActive={isActive}
        isInProgress={isActive}
        isSoundMuted={isSoundMuted}
        actionValue={actionValue}
        mediaThumbnailImageRatio={mediaThumbnailImageRatio}
      />
      <StoryButton actionValue={actionValue} />
      <div className={classnames(classes.adStoriesCardSide, classes.adStoriesCardLeftSide)} onClick={leftSideClick} />
      <div className={classnames(classes.adStoriesCardSide, classes.adStoriesCardRightSide)} onClick={rightSideClick} />
    </div>
  )
}

InstagramStoriesItem.propTypes = {
  viewAdOnFacebook: PropTypes.string,
  formikValues: PropTypes.object,
  elementInProgress: PropTypes.string,
  index: PropTypes.number,
  fileUrl: PropTypes.string,
  handleLeftSideClick: PropTypes.func,
  handleRightSideClick: PropTypes.func,
  isSoundMuted: PropTypes.bool,
  mediaThumbnailImageRatio: PropTypes.number
}

export default InstagramStoriesItem
